export const validateInput = (value) => {
    return value.match(/^\d*\.?\d{0,2}$/) ? true : false;
  };
  